<template>
  <nav
    class="inline-flex divide-x divide-gray-300 rounded border border-gray-300 shadow-sm"
  >
    <slot />
  </nav>
</template>
